module.exports = __webpack_public_path__ + "static/media/man-with-laptop.16d36729.png";